import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { boxContainer } from "../../components";
import { Images } from "../../config";

import { FaAnglesRight } from "react-icons/fa6";

import AccountSettings from "./account-settings";
import ChangePassword from "./change-password";
import PrivacyPolicy from "../privacy-policy";
import TermsAndCondition from "../terms-and-conditions";

function Settings() {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("account-settings");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get("tab");

    if (tabParam) {
      setActiveTab(tabParam);
    } else {
      setActiveTab("account-settings");
    }
  }, [location.search]);

  const settingItems = [
    {
      title: "Account Settings",
      tab: "account-settings",
      subTitle: "Change Personal Info",
      route: "/settings?tab=account-settings",
      icon: Images.AccountSettings,
    },
    {
      title: "Security Settings",
      tab: "security-settings",
      subTitle: "Change Password",
      route: "/settings?tab=security-settings",
      icon: Images.SecuritySettings,
    },
    {
      title: "Privacy Policy",
      tab: "privacy-policy",
      route: "/settings?tab=privacy-policy",
      icon: Images.SettingsPrivacyPolicy,
      subTitle: " ",
    },
    {
      title: "Terms & Conditions",
      tab: "termsnconditions",
      route: "/settings?tab=termsnconditions",
      icon: Images.SettingsPreferences,
      subTitle: " ",
    },
  ];

  return (
    <div className="text-black">
      <boxContainer.LiteBoxContainer>
        <div className="flex gap-3">
          <div className="flex flex-col gap-4 w-[40%] pr-5 border-r-[1px] border-r-liteBoxBorder">
            {settingItems?.map((item, index) => (
              <Link to={item?.route}>
                <div
                  key={index}
                  className="flex items-center !border !border-main rounded-[1.438em] cursor-pointer"
                  to={item?.route}
                  onClick={() => setActiveTab(item?.title)}
                >
                  <div className="w-[20%] h-full flex justify-center items-center">
                    <img src={item?.icon} className="h-[2.25em]" />
                  </div>
                  <div
                    className={`p-4 w-[80%]  flex justify-between items-center !border-l !border-l-main ${
                      activeTab === item?.tab
                        ? "bg-main text-white rounded-r-[1.25em]"
                        : "bg-white text-black rounded-r-[1.5em]"
                    }`}
                  >
                    <div>
                      <div className="text-[1.188em] font-semibold">
                        {item?.title}
                      </div>
                      <div className="text-[0.875em] opacity-50">
                        {item?.subTitle}
                      </div>
                    </div>
                    <FaAnglesRight fontSize={"1.25em"} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className="w-full">
            {activeTab === "account-settings" ? (
              <AccountSettings />
            ) : activeTab === "security-settings" ? (
              <ChangePassword />
            ) : activeTab === "privacy-policy" ? (
              <PrivacyPolicy />
            ) : activeTab === "termsnconditions" ? (
              <TermsAndCondition />
            ) : (
              <AccountSettings />
            )}
          </div>
        </div>
      </boxContainer.LiteBoxContainer>
    </div>
  );
}

export default Settings;
